import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Hero } from '../sections/Hero';
import { PartnershipTypes } from '../sections/PartnershipTypes';
import { Benefits } from '../sections/Benefits';
import { WhyPartner } from '../sections/WhyPartner';
import { CampaignExamples } from '../sections/CampaignExamples';
import { HowItWorks } from '../sections/HowItWorks';
import { AfterYouApply } from '../sections/AfterYouApply';
import { Faq } from '../sections/Faq';
import { OnboardingForm } from '../sections/OnboardingForm';
import { FinalCta } from '../sections/FinalCta';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-primary px-4 py-2 focus:text-white"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="main">
        <Hero />
        <PartnershipTypes />
        <Benefits />
        <WhyPartner />
        <CampaignExamples />
        <HowItWorks />
        <Faq />
        <AfterYouApply />
        <OnboardingForm />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
